export default __webpack_public_path__ + "static/media/MainLogo.11bf466a.png";